import _0x5f5551 from'./SweetAlert.js';const Swal=_0x5f5551;Swal['default']=Swal;export default Swal;